module.exports = __webpack_public_path__ + "img/sort.d9f00e4f.svg";